import { useState } from 'react'
import { SystemSS } from '../../../components/SystemSS'
import { FullScreenModal } from '../../../utility/FullScreenModal'
export const FacilitiesDungeon = () => {
    const [showModal, setShowModal] = useState(false)
    const [modalContent, setModalContent] = useState({ contentType: '', category: '', index: 1 })
    const handleOpenModal = (contentType, category, index, maxIndex) => {
        setModalContent({ contentType, category, index, maxIndex })
        setShowModal(true)
        console.log('clickd')
    }
    const handleCloseModal = () => {
        setModalContent({ contentType: '', category: '', index: 0 })
        setShowModal(false)
    }
    return (
        <>
            {' '}
            <section className=''>
                <div className='flex justify-center '>
                    <img
                        className=''
                        alt='confine'
                        src={`${process.env.PUBLIC_URL}/images/system/system-dungeon.webp`}
                    />
                </div>
                <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full md:w-4/5 px-4 md:px-0 mx-auto mt-12'>
                    <p>
                        By creating random dungeons and completing them, you can <span className='text-pborange'>level up your units, find items</span>, and <span className='text-pborange'>strengthen Titles</span>. Dungeons are created by using a <span className='text-pborange'>Map</span>. The Map's name will determine the dungeon’s location, enemies, stats, and obtainable items.
                    </p>{' '}<br/>
                    <p>
                        When creating a random dungeon, you can freely choose its Title and, when you clear the dungeon, you will receive the Title you created as a <span className='text-pborange'>reward</span>.
                    </p>{' '}<br/>
                    <p>
                        Be sure to level up all the Titles you create!
                    </p>{' '}
                    <SystemSS
                        mediaItems={[
                            {
                                modalId: 'dungeon',
                                index: 1,
                            },
                        ]}
                        handleOpenModal={handleOpenModal}
                        description='When you create a dungeon, you’ll receive the name you set as a Title upon clearing it. Try making up your own, original Titles!'
                    />{' '}
                    <SystemSS
                        mediaItems={[
                            {
                                modalId: 'dungeon',
                                index: 2,
                            },
                        ]}
                        handleOpenModal={handleOpenModal}
                    />{' '}
                      <p>
                        As you progress through a dungeon’s floors, the enemies' levels will increase, which in turn <span className='text-pborange'>strengthens</span> the Title of the dungeon. In addition, the chance that <span className='text-pborange'>rare items will appear also increases</span>. 
                    </p>{' '}<br/>
                    <p>
                        In addition, there are <span className='text-pborange'>floor bonuses</span> that allow you to obtain more EXP. Also, every 10th floor, an <span className='text-pborange'>event</span> might occur where you will encounter a Gadget that only appears in dungeons, the Slot Machine. This gives you the <span className='text-pborange'>chance</span> to earn more EXP, Mana, or BOR. If you're lucky, you might get a rare item, but if you're unlucky, something horrible might happen. Still, it's a great chance to strike it rich and power up!
                    </p>{' '}
                    <SystemSS
                        mediaItems={[
                            {
                                modalId: 'dungeon',
                                index: 3,
                            },
                        ]}
                        handleOpenModal={handleOpenModal}
                    />{' '}
                    <p>
                        However, if you are defeated in a dungeon, you will lose all obtained items and EXP. As you advance, enemies will get stronger and stronger. Be sure to <span className='text-pborange'>exit the dungeon when you can</span>, or proceed with the utmost caution! 
                    </p>{' '}
                    <SystemSS
                        mediaItems={[
                            {
                                modalId: 'dungeon',
                                index: 4,
                            },
                        ]}
                        handleOpenModal={handleOpenModal}
                        description={"Aside from completely clearing every floor, you are only able to exit a dungeon every 10 floors by using the exit or at any time using the Explorer’s special command, Return. It is also possible to create a temporary save in the random dungeons. To resume, just select “Continue” from the Title Screen."}
                    />{' '}
                </div>{' '}
            </section>{' '}
            <FullScreenModal
                showModal={showModal}
                modalContent={modalContent}
                setModalImage
                handleCloseModal={handleCloseModal}
                setModalContent={setModalContent}
                maxIndex={4}
            />
        </>
    )
}
